import { render } from "./EditWorkRelated.vue?vue&type=template&id=24858613"
import script from "./EditWorkRelated.vue?vue&type=script&lang=js"
export * from "./EditWorkRelated.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__